import { Content } from '@prismicio/client';
import { PrismicLink, SliceComponentProps } from '@prismicio/react';

// Components
import { Feature } from '@/slices/navigation/SubMenuItem/Feature';
import { LinkList } from '@/slices/navigation/SubMenuItem/LinkList';

export type SubMenuItemProps = SliceComponentProps<Content.SubMenuItemSlice>;

const SubMenuItem = ({ slice }: SubMenuItemProps) => (
  <>
    {slice.variation === 'feature' && <Feature slice={slice} />}
    {slice.variation === 'linkList' && <LinkList slice={slice} />}
    {slice.variation === 'default' && (
      <PrismicLink field={slice.primary.link} />
    )}
  </>
);

export default SubMenuItem;
